export var StaffCalculate;
(function (StaffCalculate) {
  StaffCalculate["Headcount"] = "Headcount";
  StaffCalculate["FTE"] = "FTE";
})(StaffCalculate || (StaffCalculate = {}));
export var RoleAppliesTo;
(function (RoleAppliesTo) {
  RoleAppliesTo["Queue"] = "queue";
  RoleAppliesTo["Site"] = "site";
})(RoleAppliesTo || (RoleAppliesTo = {}));
export var WageType;
(function (WageType) {
  WageType["Hourly"] = "hourly";
  WageType["AnnualSalary"] = "annual_salary";
})(WageType || (WageType = {}));